import { OrganizerCarousel } from '@eventbrite/collection-carousel';
import { gettext } from '@eventbrite/i18n';
import { Location } from 'history';
import React from 'react';
import { UserShape } from '../../../../types';
import { CategoryBrowseBucket } from '../../components/CategoryBrowseBucket';
import { HEAP_PAGE_AREA } from '../../constants/heap';
import { useBaseEventsQueryEvents } from '../../hooks/queries/events';
import { useOrganizerIdsInEvents } from '../../hooks/queries/organizers';
interface CategoryBrowseOrganizersProps {
    user: UserShape;
    location: Location;
}

export const CategoryBrowseOrganizers: React.FunctionComponent<
    CategoryBrowseOrganizersProps
> = (props) => {
    const { data: organizerIds } = useOrganizerIdsInEvents();
    const { data } = useBaseEventsQueryEvents({
        optOutDedupeEvents: true,
    });
    const baseEvents = data?.events || [];

    if (!baseEvents || !organizerIds) {
        //return stub with height
        return <section style={{ minHeight: '250px' }}></section>;
    }

    //No events to pull from or no organizer IDs to display
    if (baseEvents.length === 0 || organizerIds.length === 0) {
        return null;
    }

    return (
        <CategoryBrowseBucket>
            <OrganizerCarousel
                pageArea={HEAP_PAGE_AREA}
                organizerIds={organizerIds}
                location={props.location}
                headerTitle={gettext('Organizers to follow')}
                publicId={props.user?.publicId}
                isAuthenticated={props.user?.isAuthenticated}
            />
        </CategoryBrowseBucket>
    );
};
